import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { secondAxios } from "../../../../../../api/axios";
// import { sendEmail } from "../api"; // Replace with actual email sending function

export const sendEmail = async (id, { body }) => {
  try {
    console.log("sending", body);
    if (body == "") {
      alert("please enter email body");
    }

    const response = await secondAxios.post(`/raci/send-email/${id}`, {
      body,
    });
    console.log("rrrr", response);

    if (!response.data.success) {
      throw new Error("Email sending failed");
    }

    return response;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error;
  }
};

const EmailDialog = ({ open, handleClose, row }) => {
  const [emailBody, setEmailBody] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setEmailBody("");
  }, [row]);

  const handleSendEmail = async () => {
    if (!emailBody) {
      alert("Please enter the email body.");
      return;
    }

    setIsLoading(true);

    try {
      const resp = await sendEmail(row.id, { body: emailBody });
      console.log("rrrr", resp);

      alert("Email sent successfully!");
      handleClose();
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Send Email</DialogTitle>
      <DialogContent>
        <Typography variant="h6" gutterBottom>
          {row?.document}
        </Typography>
        <Typography variant="h6" gutterBottom>
          Enter the body of your email below:
        </Typography>
        <TextField
          label="Email Body"
          multiline
          rows={6}
          fullWidth
          value={emailBody}
          onChange={(e) => setEmailBody(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSendEmail}
          variant="contained"
          color="primary"
          disabled={isLoading}
        >
          {isLoading ? "Sending..." : "Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailDialog;
